// tslint:disable:jsx-no-lambda
import * as React from 'react';

import { Button, Icon, Modal } from '@abb/common-ux';

interface IDownloadModalState {
  selectedOption: 'blank' | 'existing';
}

interface IConfirmationModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  loadingText?: string | null;
  onClose: () => void;
  onSubmit: (selectedOption: 'blank' | 'existing') => void;
}

export class NewRequestConfirmationModel extends React.Component<IConfirmationModalProps, IDownloadModalState> {
  constructor(props: any) {
    super(props);
    
    this.state = {
      selectedOption: 'existing'
    };
  }

  onApply = () => {
    this.props.onSubmit(this.state.selectedOption);
  }

  render() {
    const footerElem = (
      <div className='text-right'>
        <span style={{marginRight: '10px'}} >{this.props.isLoading ? this.props.loadingText : ''}</span>
        <Button buttonType='normal' buttonSize='default' onClick={this.props.onClose}>Cancel</Button>
        <Button buttonType='primary' buttonSize='default' onClick={this.onApply} disabled={this.props.isLoading}>Continue</Button>
      </div>
    );

    return (
      <Modal header={'New Request'} isOpen={this.props.isOpen} onClose={this.props.onClose} footer={footerElem} modalClassName='newRequestConfirmationModal'>
        <div className='row'>
          <div className='col-sm-12'>
            <span>Uploading a new parts list will restart this process, including the review by an ABB Parts Specialist.</span>
          </div>
        </div>
      </Modal>
    );
  }
}
